import { ActionIcon, Popover, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons";
import React from "react";

const FieldLabelGuide = ({
  label,
  title,
  children,
  ariaLabel,
  width = 420,
}) => {
  const heading = ariaLabel || `${title || label} guide`;
  const body =
    typeof children === "string" || typeof children === "number" ? (
      <Text size="sm">{children}</Text>
    ) : (
      children
    );

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        maxWidth: "100%",
      }}
    >
      <span>{label}</span>
      <Popover
        width={width}
        position="bottom-start"
        withArrow
        shadow="md"
        withinPortal
      >
        <Popover.Target>
          <ActionIcon
            size="xs"
            variant="subtle"
            color="gray"
            aria-label={heading}
            onMouseDown={(event) => event.preventDefault()}
          >
            <IconInfoCircle size={16} />
          </ActionIcon>
        </Popover.Target>
        <Popover.Dropdown sx={{ maxHeight: 420, overflow: "auto" }}>
          {title ? (
            <Text size="sm" weight={600} mb={6}>
              {title}
            </Text>
          ) : null}
          {body}
        </Popover.Dropdown>
      </Popover>
    </span>
  );
};

export default FieldLabelGuide;
